import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import LockIconWrapper from '../components/LockIconWrapper';

function InvoiceCancelDialog({ open, onClose, invoice, onSaved, createCancellation }) {
  const [lines, setLines] = useState([]);

  useEffect(() => {
    if (invoice) {
      // Build map of already cancelled counts from grouped children (if present)
      const refundedMap = new Map();
      (invoice.children || [])
        .filter(c => c.type === 'cancellation')
        .forEach(c => {
          (c.lineItems || []).forEach(it => {
            const key = it.originalLineItemId?.toString();
            if (!key) return;
            refundedMap.set(key, (refundedMap.get(key) || 0) + Math.abs(it.count || 0));
          });
        });

      const computed = (invoice.lineItems || []).map(li => {
        const key = li._id.toString();
        const already = refundedMap.get(key) || 0;
        const remaining = Math.max(0, (li.count || 0) - already);
        return {
          id: key,
          description: li.description,
          available: remaining,
          original: li.count || 0,
          countToCancel: 0,
        };
      });
      setLines(computed);
    }
  }, [invoice]);

  const handleChange = (idx, value) => {
    const count = Math.max(0, Math.min(parseInt(value || '0', 10) || 0, lines[idx].available));
    const copy = [...lines];
    copy[idx].countToCancel = count;
    setLines(copy);
  };

  const handleSubmit = async () => {
    const reductions = lines
      .filter(l => l.countToCancel > 0)
      .map(l => ({ lineItemId: l.id, countToCancel: l.countToCancel }));
    if (!reductions.length) {
      toast.info('Keine Positionen zur Stornierung ausgewählt.');
      return;
    }
    try {
      const result = await createCancellation(invoice._id, reductions);
      toast.success('Stornorechnung erstellt.');
      onSaved?.(result);
      onClose();
    } catch (e) {
      toast.error('Fehler beim Erstellen der Stornorechnung.');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>Positionen stornieren</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          {lines.map((l, idx) => (
            <Grid item xs={12} key={l.id.toString()}>
              <Grid container spacing={1} alignItems='center'>
                <Grid item xs={8}>
                  <Typography variant='body2'>{l.description}</Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='caption'>Verfügbar: {l.available}</Typography>
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    type='number'
                    size='small'
                    value={l.countToCancel}
                    onChange={e => handleChange(idx, e.target.value)}
                    inputProps={{ min: 0, max: l.available }}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button onClick={handleSubmit} variant='contained'>
          <LockIconWrapper right='invoice:update'>Stornieren</LockIconWrapper>
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default InvoiceCancelDialog;
